import Page from 'src/components/page/page'

import { useAdmDetails } from './adm-details.hook'
import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import AdmForm from './components/adm-form/adm-form';

export default function AdmDetails() {
  const {
    isEdit,
    isLoadingAdmToEdit,
    isSubmitting,
    methods,
    userPermissions,
    onChangePermissions,
    handleSubmit,
    onSubmit,
  } = useAdmDetails();
  return (
    <Page title={isEdit ? "Editar Administrador" : "Cadastrar Administrador"}>
      <Container maxWidth='lg'>
        <HeaderBreadcrumbs
          heading={isEdit ? "Editar Administrador" : "Cadastrar Administrador"}
          links={[]}
        />
        {isLoadingAdmToEdit ?
          <Box flexGrow={1} display='flex' justifyContent='center' alignItems='center' mt={30}>
            <CNLoading />
          </Box>
          :
          <AdmForm
            userPermissions={userPermissions}
            isEdit={isEdit}
            isSubmitting={isSubmitting}
            methods={methods}
            onChangePermissions={onChangePermissions}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
          />
        }
      </Container>
    </Page>
  )
}
